import React, { useContext, useState } from 'react';
import branchService from 'ApiService/SuperAdmin/branchService';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import { AuthContext } from 'contexts/AuthContext';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from 'pages/Common/ConfirmationModal';

function AddBranch() {
  const { state } = useContext(AuthContext);
  const [branchData, setBranchData] = useState({
    name: '',
    location: '',
  });
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleChange = (event) => {
    setBranchData({ ...branchData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!branchData.name || !branchData.location) {
      toast.error('All fields are mandatory.');
      return;
    }

    setIsModalOpen(true);
  };

  const confirmCreation = async () => {
    setIsModalOpen(false);
    setLoading(true);

    try {
      const response = await branchService.createBranch({ ...branchData });
      if (response.data.success) {
        setBranchData({ name: '', location: '' });
        toast.success(response.data.message);
        // navigate('/branches');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error creating branch');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card extra="max-w-[405px] md:max-w-[510px] md:w-[510px] h-max mx-2.5 md:mx-auto mt-[50px] mb-auto py-2.5 px-4 md:!p-[50px] pt-8 md:pt-[50px]">
        <h3 className="mb-[10px] text-4xl font-bold text-gray-900 dark:text-white">
          Hello! Super Admin
          <br /> Create Branch
        </h3>
        <p className="mb-4 ml-1 text-base text-gray-600">
          Enter Branch Name and Location to create!
        </p>
        <InputField
          variant="auth"
          extra="mb-3"
          label="Name*"
          placeholder="eg. New Branch Name"
          id="name"
          maxLength={50}
          type="text"
          onChange={handleChange}
          name="name"
          value={branchData.name}
        />
        <InputField
          variant="auth"
          extra="mb-3"
          label="Location*"
          placeholder="eg. 123 Main St"
          id="location"
          maxLength={60}
          type="text"
          onChange={handleChange}
          name="location"
          value={branchData.location}
        />
        <button
          disabled={loading}
          onClick={handleSubmit}
          className="mt-4 w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
        >
          Create
        </button>
      </Card>

      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={confirmCreation}
        title="Confirm Branch Creation"
        message={`Are you sure you want to create the branch "${branchData.name}" at "${branchData.location}"?`}
        confirmText="Yes, Create"
        cancelText="Cancel"
        icon="info"
      />
    </>
  );
}

export default AddBranch;
